<template>
  <div v-if="organization">
    <side-bar-large
      v-if="large"
      :sections="sections"
      v-on:update:toggleSideBarLarge="toggle()">
    </side-bar-large>
    <side-bar-small
    v-else
    :sections="sections"
    v-on:update:toggleSideBarSmall="toggle()">
    </side-bar-small>
  </div>
</template>

<script>
import SideBarLarge from '@/components/SideBarLarge.vue';
import SideBarSmall from '@/components/SideBarSmall.vue';

export default {
  name: 'SideBar',
  components: { SideBarLarge, SideBarSmall },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  created() {
    if (this.organization.hd === 'digitasecurity.com') {
      this.sections.push({
        name: 'Administration',
        links: [
          {
            name: 'admin.organizations.index',
            image: 'shield',
            label: 'Admin',
          },
        ],
      });
    }
  },
  data() {
    return {
      large: true,
      sections: [
        {
          name: this.organization.name,
          links: [
            {
              name: 'dashboard.index',
              image: 'dashboard',
              label: 'DashBoard',
            },
            {
              name: 'alerts.index',
              image: 'alert',
              label: 'Alerts',
            },
            {
              name: 'logs.index',
              image: 'log',
              label: 'Logs',
            },
            {
              name: 'assets.index',
              image: 'macbookpro',
              label: 'Assets',
            },
          ],
        },
        // {
        //   name: 'Analyze',
        //   links: [
        //     {
        //       url: 'https://search-gameplan-thve5xfaf5f5pjw4qw4g3b4znq.us-east-1.es.amazonaws.com/_plugin/kibana/app/kibana',
        //       image: 'context',
        //       label: 'Kibana',
        //     },
        //   ],
        // },
        {
          name: 'Configuration',
          links: [
            {
              name: 'analytics.index',
              image: 'logic',
              label: 'Analytics',
            },
            {
              name: 'profiles.index',
              image: 'profile',
              label: 'Profiles',
            },
            {
              name: 'actions.index',
              image: 'action',
              label: 'Actions',
            },
            {
              name: 'deployments.index',
              image: 'pkg',
              label: 'Deployments',
            },
            // {
            //   name: 'insights.config',
            //   image: 'insight',
            //   label: 'Insights',
            // },
          ],
        },
        {
          name: 'Information',
          links: [
            {
              name: 'account',
              image: 'org',
              label: 'Account Info',
            },
            {
              name: 'documentation',
              image: 'help',
              label: 'Documentation',
            },
          ],
        },
      ],
    };
  },
  methods: {
    toggle() {
      this.large = !this.large;
    },
  },
};
</script>

<style lang="scss" scoped>

#sidebar2 {
  width: 60px;
}

.menu-list {
  img, svg {
    height: 40px;
    width: 40px;
  }

  a {
    padding: 0;
  }
}

#sidebar, #sidebar-small {
  background-color: $navbar-background;
  border-right: 1px solid $border-color;
}

.logo {
  height: $navbar-height;
  border-bottom: 1px solid $border-color;
  text-align: center;
  margin-bottom: 0;
  background-color: $navbar-background;

  .level-left {
    margin: 0 auto;

    img {
      margin-right: 0;
    }

    p {
      font-family: 'Avenir Next', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-weight: 500;
    }
  }
}

aside {
  padding: 10px;

  .menu-list a {
    color: $font-color;
    border-radius: 0;
  }

  .menu-list a:hover {
    background-color: $border-color;
  }

  .menu-list a.is-active {
    background-color: $sidebar-active;
  }
}
</style>
